import Cookies from 'js-cookie'
const expireDay = 365
const pathName = ''

const TokenKey = 'passport'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: expireDay, path: pathName })
}

export function removeToken() {
  return Cookies.remove(TokenKey, { path: pathName })
}

const userKey = 'user'

export function getUserInfo() {
  return JSON.parse(Cookies.get(userKey) || null)
}

export function setUserInfo(val) {
  const data = {
    id: val.id,
    nickName: val.nickName,
    mobile: val.mobile,
    avatar: val.avatar,
    hasCertificate: val.hasCertificate
  }
  return Cookies.set(userKey, data, { expires: expireDay, path: pathName })
}

export function removeUserInfo() {
  return Cookies.remove(userKey, { path: pathName })
}

const wxKey = 'wxInfo'

export function getWXInfo() {
  return JSON.parse(Cookies.get(wxKey) || null)
}

export function setWXInfo(val) {
  return Cookies.set(wxKey, val, { expires: expireDay, path: pathName })
}

export function removeWXInfo() {
  return Cookies.remove(wxKey, {path: pathName})
}



// WEBPACK FOOTER //
// ./src/libs/cookie-storage.js